var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconColorOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.495,
    height: 14.33,
    viewBox: "0 0 21.495 14.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-folder-open",
    "data-name": "Icon awesome-folder-open",
    d: "M21.371,13.012l-2.7,4.633a2.388,2.388,0,0,1-2.063,1.185H1.68a.9.9,0,0,1-.774-1.347l2.7-4.633a2.388,2.388,0,0,1,2.063-1.185H20.6A.9.9,0,0,1,21.371,13.012Zm-15.7-2.541h12.24V8.68a1.791,1.791,0,0,0-1.791-1.791H10.15L7.762,4.5H1.791A1.791,1.791,0,0,0,0,6.291V16.667l2.578-4.419A3.6,3.6,0,0,1,5.672,10.471Z",
    transform: "translate(0 -4.5)",
    fill: "#024D82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconColorOpen);
export default __webpack_public_path__ + "static/media/icon-color-open.dd3f9ebc837da63c694bec7b83c5c3c1.svg";
export { ForwardRef as ReactComponent };